import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useState, useEffect, useMemo } from "react"
import blb from "../images/navbar/blb-reduced-logo.png"
import bigBlb from "../images/navbar/BLB-logo-entier.png"
import facebook from "../images/navbar/facebook.svg"
import instagram from "../images/navbar/instagram.svg"
import linkedin from "../images/navbar/linkedin.svg"
import twitter from "../images/navbar/twitter.svg"
import blblogomobile from "../images/navbar/logo-blb-blanc.svg"
import MyDropdown from "./MyDropdown"
import MyLink from "./MyLink"

const Header = ({ lang, location }) => {
  const links = useMemo(() => {
    return [
      {
        name: "BLB VIGNOBLES",
        link: null,
        links: [
          {
            name:
              lang === "fr" ? "VISION DE BRUNO LE BRETON" : "BRUNO LE BRETON'S VISION",
            link: lang === 'fr' ? '/fr/la-vision-de-bruno-le-breton' : '/en/bruno-le-breton-vision',
          },
          {
            name: lang === "fr" ? "VALEURS" : "VALUES",
            link: lang === 'fr' ? '/fr/valeurs-et-missions' : '/en/values-and-missions',
          },
          {
            name:
              lang === "fr" ? "HISTOIRE & CHIFFRES CLÉS" : "HISTORY & KEY FIGURES",
            link: lang === 'fr' ? '/fr/histoire-de-blb-vignobles' : '/en/histoiry-of-blb-vignobles',
          },
          {
            name:
              lang === "fr" ? "ÉQUIPE & RECRUTEMENT" : "TEAM AND CAREERS",
            link: lang === 'fr' ? '/fr/equipe-et-recrutement' : '/en/team-and-careers',
          },
          {
            name:
              lang === "fr" ? "SOCIÉTÉ À MISSION" : "PURPOSE AND MISSION",
            link: lang === 'fr' ? '/fr/societe-a-mission' : '/en/purpose-mission',
          },
        ],
      },
      {
        name: lang === "fr" ? "NOS VINS" : "OUR WINES",
        link: null,
        links: [
          {
            name: lang === "fr" ? "LA JASSE" : "LA JASSE",
            link: lang === 'fr' ? '/fr/domaine-de-la-jasse' : '/en/la-jasse-wines',
          },
          {
            name: lang === "fr" ? "MONTLOBRE" : "MONTLOBRE",
            link: lang === 'fr' ? '/fr/domaine-montlobre' : '/en/montlobre-wines',
          },
          {
            name:
              lang === "fr" ? "VIGNES DES DEUX SOLEILS" : "VIGNES DES DEUX SOLEILS",
            link: lang === 'fr' ? '/fr/vignes-des-deux-soleils' : '/en/vignes-des-deux-soleils-wines',
          },
          {
            name:
              lang === "fr" ? "OÙ TROUVER NOS VINS" : "WHERE TO FIND OUR WINES",
            link: lang === 'fr' ? '/fr/ou-trouver-nos-vins' : '/en/finding-our-wines',
          },
        ],
      },
      {
        name: lang === "fr" ? "DÉMARCHE RSE" : "CSR APPROACH",
        link: null,
        links: [
          {
            name:
              lang === "fr"
                ? "AXE 1 : ENGAGER LES ACTEURS DE LA FILIÈRE SUR LA CRÉATION D'UN VIN RESPONSABLE"
                : "TO COMMIT THE INDUSTRY PLAYERS TO CREATING AN ETHICALLY-MADE WINE",
            link: lang === 'fr' 
                ? '/fr/axe-1-engager-la-filiere-sur-la-creation-dun-vin-responsable' 
                : '/en/committing-the-industry-creating-sustainable-wine',
          },
          {
            name:
              lang === "fr"
                ? "AXE 2 : DIMINUER ET VALORISER NOS IMPACTS SUR LE VIVANT"
                : "TO REDUCE AND ENHANCE OUR IMPACT ON THE LIVING",
            link: lang === 'fr' 
                ? '/fr/axe-2-preserver-et-respecter-notre-capital-humain-et-notre-environnement' 
                : '/en/protecting-and-respecting-our-human-resources-and-our-environment',
          },
          {
            name:
              lang === "fr"
                ? "AXE 3 : STRUCTURER NOTRE ENTREPRISE POUR QU'ELLE SOIT RESILIENTE"
                : "TO STRUCTURE OUR FAMILY WINERY SO THAT IT IS RESILIENT",
            link: lang === 'fr' 
                ? '/fr/axe-3-maitriser-notre-empreinte-sur-nos-territoires' 
                : '/en/controlling-our-footprint-across-our-regions',
          },
          {
            name:
              lang === "fr"
                ? "AXE 4 : PARTAGER AUJOURD'HUI POUR PROFITER ENCORE DEMAIN"
                : "TO SHARE TODAY TO BENEFIT TOMORROW",
            link: lang === 'fr' 
                ? '/fr/axe-4-partager-aujourdhui-pour-profiter-encore-demain' 
                : '/en/sharing-today-benefitting-tomorrow',

          },
        ],
      },
      {
        name: lang === "fr" ? "AVIS" : "REVIEWS",
        link: lang === 'fr' ? '/fr/avis' : '/en/reviews',
        links: [],
      },
      {
        name: lang === "fr" ? "BLOG" : "BLOG",
        link: lang === 'fr' ? '/fr/blog' : '/en/blog',
        links: [],
      },
      {
        name: lang === "fr" ? "FAQ" : "FAQ",
        link: lang === 'fr' ? '/fr/faq' : '/en/faq',
        links: [],
      },
      {
        name: lang === "fr" ? "TÉLÉCHARGEMENTS" : "DOWNLOADS",
        link: lang === 'fr' ? '/fr/telechargements' : '/en/downloads',
        links: [],
      },
      {
        name: lang === "fr" ? "PARTENAIRES" : "PARTNERS",
        link: lang === 'fr' ? '/fr/partenaires' : '/en/stakeholders',
        links: [],
      },
      {
        name: lang === "fr" ? "CONTACT" : "CONTACT",
        link: lang === 'fr' ? '/fr/contact' : '/en/contact-us',
        links: [],
      },
    ]
  }, [lang])

  const [showMenu, setShowMenu] = useState(false)
  const [scrollTop, setScrollTop] = useState(true)
  const [hasRan, setHasRan] = useState(false)
  const [screenSize, setScreenSize] = useState({
    height: 0,
    width: 0,
  })
  const [selectedDropdown, setSelectedDropdown] = useState(null)

  const changeShowMenu = () => {
    setShowMenu(!showMenu)
  }

  useEffect(() => {
    const onScroll = e => {
      if ((e.target.documentElement.scrollTop === 0) !== scrollTop) {
        setScrollTop(!scrollTop)
      }
    }
    window.addEventListener("scroll", onScroll)

    return () => window.removeEventListener("scroll", onScroll)
  }, [scrollTop])

  const updateScreenSize = () => {
    setScreenSize({ width: window.innerWidth, height: window.innerHeight })
  }

  useEffect(() => {
    if (!hasRan) {
      setHasRan(true)
      updateScreenSize()
    }
    window.addEventListener("resize", updateScreenSize)
    return () => {
      window.removeEventListener("resize", updateScreenSize)
    }
  }, [screenSize, hasRan])

  const handleClickDropdown = buttonName => {
    setSelectedDropdown(buttonName === selectedDropdown ? null : buttonName)
  }

  return (
    <header className={showMenu ? "show" : null}>
      <div className={`my-navbar${scrollTop ? " big" : ""}`}>
        <div className="mobile-navbar">
          <a href={`/${lang}/`}>
            <img
              className="mobile-logo"
              src={blblogomobile}
              alt="logo blb vignobles"
            />
          </a>
          <div className="language-buttons">
            <a href="/fr/" className={lang === "fr" ? "active" : null}>
              <span>FR</span>
            </a>
            &nbsp;-&nbsp;
            <a href="/en/" className={lang === "en" ? "active" : null}>
              <span>EN</span>
            </a>
          </div>
          <button onClick={changeShowMenu}>
            {showMenu ? (
              <FontAwesomeIcon icon={faTimes} />
            ) : (
              <FontAwesomeIcon icon={faBars} />
            )}
          </button>
        </div>
        <div className="my-navbar-container">
          {links.map(link =>
            link.links.length > 0 ? (
              <MyDropdown
                key={link.name}
                name={link.name}
                children={link.links}
                selectedDropdown={selectedDropdown}
                location={location}
                click={handleClickDropdown}
              />
            ) : (
              <MyLink
                key={link.name}
                link={link.link}
                name={link.name}
                location={location}
              />
            )
          )}
        </div>
      </div>
      <div
        className={`left-navbar${
          scrollTop && screenSize.width > 1500 ? " big" : ""
        }`}
      >
        <a href={`/${lang}/`}>
          <img
            src={scrollTop && screenSize.width > 1500 ? bigBlb : blb}
            className="blb-logo"
            alt="logo BLB vignobles"
          />
        </a>
        <div className="language-buttons">
          <a href="/fr/" className={lang === "fr" ? "active" : null}>
            <span>FR</span>
          </a>
          <a href="/en/" className={lang === "en" ? "active" : null}>
            <span>EN</span>
          </a>
        </div>
        <a
          className="social-network"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/blbvignobles/"
        >
          <img src={facebook} alt="facebook icon" />
        </a>
        <a
          className="social-network"
          target="_blank"
          rel="noopener noreferrer"
          href="https://twitter.com/blb_vignobles/"
        >
          <img src={twitter} alt="twitter icon" />
        </a>
        <a
          className="social-network"
          target="_blank"
          rel="noopener noreferrer"
          href="https://linkedin.com/company/blbvignobles/"
        >
          <img src={linkedin} alt="linkedin icon" />
        </a>
        <a
          className="social-network"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.instagram.com/blb_vignobles/"
        >
          <img src={instagram} alt="instagram icon" />
        </a>
      </div>
    </header>
  )
}

export default Header
